// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1qZ8h";
export var textContainer = "styles-module--textContainer---IZs2";
export var title = "styles-module--title--2NUr4";
export var content = "styles-module--content--ghi5B";
export var grid = "styles-module--grid--mUTzt";
export var card = "styles-module--card--2Kc_j";
export var iconContainer = "styles-module--iconContainer--1EAHR";
export var icon = "styles-module--icon--2-yYf";
export var cardText = "styles-module--cardText--2-hhv";